import { QUESTION_CREATION_TASK_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { Button, CheckCircleOutlineRoundedIcon } from '@shared/components';

interface FinishTaskButtonProps {
  onFinish: () => void;
}

export default function FinishTaskButton(props: Readonly<FinishTaskButtonProps>) {
  const { onFinish } = props;

  return (
    <Button
      startIcon={<CheckCircleOutlineRoundedIcon />}
      onClick={onFinish}
      data-testid={QUESTION_CREATION_TASK_DATA_TEST_ID.FINISH_TASK_BUTTON}
    >
      Finish Task
    </Button>
  );
}
